import React, { useEffect, useState,useContext } from 'react'
import { Link, useNavigate } from "react-router-dom"
import { Mail, Lock, EyeOff,Eye } from "react-feather"
import { GoogleLogin } from "@react-oauth/google";
import { UserContext,CartContext } from '@/App'
import Loader from '../components/Loader'
import Input from "@/components/Input"
import Button from "@/components/Button"
import Alert from "@/components/Alert"
import api from '../api';

export default function LoginForm({ onSubmit }) {
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [error, setError] = useState("")
	const [loading, setLoading] = useState("")
	const [showPassword, setShowPassword] = useState(false);	
	const {setUser} = useContext(UserContext)
	const {cart} = useContext(CartContext)
	const navigate = useNavigate()

	const handleSubmit = async e => {
		e.preventDefault()
		setLoading(true)
		const resp = await onSubmit({email, password})
		setLoading(false)
		if (resp.status == "error") {
			setError(resp.message)
		}
	}

		const handleGoogleRegister = async (credentialResponse) => {
				const resp = await api.registerUserWithGoogle({
					token:credentialResponse.credential
				})
				console.log(resp);
				if (resp.status == "ok") {
							const loginResp = await api.loginGoogleUser({
								email : resp.data.email,
								verified :resp.verified,
							})
							if (loginResp.status == "ok") {
								setUser(api.getUser())
							   const existingCart = await api.getUserCart();
							   console.log("existing cart",existingCart) 
							   if(existingCart == null){
								await api.createUserCart({
									user: api.getUser(),  
									products: cart.products 
								 })
							   }
								if (existingCart?.products?.length) {
									navigate("/cart")
								} else {
									navigate("/account")
								}
							}
						}
						return resp
			}

	useEffect(() => {
		return () => {
			setLoading(false)
		}
	}, [])

	return (
		<form
			className="flex items-center flex-col space-y-2"
			onSubmit={handleSubmit}
		>
			<Input 
				value={email}
				onChange={e => setEmail(e.target.value)}
				icon={<Mail width={20} height={20} />}
				type="email" placeholder="Email" required />
			<Input 
				value={password}
				icon={<Lock width={20} height={20} />}
				onChange={e => setPassword(e.target.value)}
				type={showPassword ? "text" :"password"} 
				placeholder="Password" 
				required 
				rightIcon={
					   <div onClick={() => setShowPassword(!showPassword)} className="cursor-pointer">
                       {showPassword ?<Eye size={20} /> : <EyeOff size={20} /> }
                        </div>
      				}
				/>

			{error && <Alert heading="Error!" body={error} danger />}

			<Button 
				className="w-full !mt-6 !text-base !rounded-full" 
				type="submit"
				disabled={loading}
			>
				{loading ? <Loader /> : "Login"}
			</Button>

			<GoogleLogin
			onSuccess={handleGoogleRegister}
			onError={()=> alert("Google Login Failed")}>
			</GoogleLogin>
				
			<Link to="/register">
				<Button link>
					Create an account
				</Button>
			</Link>
			
			<Link to="/ForgotPassword">
				<Button link>
					Forgot password
				</Button>
			</Link>
		</form>
	)
}